// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 580) return "static/chunks/580-5043fb9cf47f7aa5.js";
	if (chunkId === 707) return "static/chunks/707-58aa2f04fbca2e79.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"145":"b79fd6e1e7facde2","164":"2e931414b4511119","458":"37d6a942d2a96e94","894":"a2bfb92fe843c139","905":"ec2e8eff530bf577"}[chunkId] + ".js";
};